import { render, staticRenderFns } from "./surveyFinishMark.vue?vue&type=template&id=0c8e2117&scoped=true"
import script from "./surveyFinishMark.vue?vue&type=script&lang=js"
export * from "./surveyFinishMark.vue?vue&type=script&lang=js"
import style0 from "./surveyFinishMark.vue?vue&type=style&index=0&id=0c8e2117&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e2117",
  null
  
)

export default component.exports